import React, { useCallback, useContext, useEffect, useState } from "react";
import { Alert, Spinner, Table } from "reactstrap";
import { AppContext } from "../../context";
import { getCatalogProductsDashboard } from "../production/service";
import { toErrorText } from "./storeSalesDashboardHelpers";
import "./StoreSalesDashboard.css";

const StoreCPDashboard = () => {
  const { currentUser } = useContext(AppContext);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadDashboard = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getCatalogProductsDashboard();
      setRows(data);
    } catch (err) {
      setRows([]);
      setError(toErrorText(err, "Unable to load catalog products dashboard."));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!currentUser?.admin) return;
    loadDashboard();
  }, [currentUser?.admin, loadDashboard]);

  if (!currentUser?.admin) {
    if (currentUser) {
      return (
        <div className="min-vh-100 w-100 mw-100 bg-light">
          <div className="container-fluid py-4 px-3 px-lg-4 w-100 mw-100">
            <Alert color="danger" fade={false}>
              UNAUTHORIZED
            </Alert>
          </div>
        </div>
      );
    }

    return null;
  }

  return (
    <div className="min-vh-100 w-100 mw-100 bg-light">
      <div className="container-fluid py-4 px-3 px-lg-4 w-100 mw-100">
        <h1 className="h4 fw-bold mb-4">CP Dashboard</h1>

        <div className="store-dashboard-tab-panel rounded border p-3">
          {error && (
            <Alert color="danger" fade={false}>
              {error}
            </Alert>
          )}

          {loading ? (
            <div className="py-5 text-center text-muted">
              <Spinner className="me-2" />
              Loading…
            </div>
          ) : (
            <div className="table-responsive">
              <Table
                bordered
                hover
                responsive
                className="mb-0 store-sales-table"
              >
                <thead className="store-sales-table__head">
                  <tr>
                    <th>Name</th>
                    <th>Top Used SKUs</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.length === 0 ? (
                    <tr>
                      <td colSpan={2} className="text-muted text-center py-4">
                        No catalog products found.
                      </td>
                    </tr>
                  ) : (
                    rows.map((row) => (
                      <tr key={row.id}>
                        <td>{row.name}</td>
                        <td>
                          {Array.isArray(row.top_used_skus) &&
                          row.top_used_skus.length > 0 ? (
                            <div className="d-flex flex-column gap-1 small">
                              {row.top_used_skus.map((sku) => (
                                <div key={`${row.id}-${sku.store_product_id}`}>
                                  {sku.code} ({sku.count})
                                </div>
                              ))}
                            </div>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoreCPDashboard;
